<template>
  <main class="row m-0">
    <div class="col-12">
      <div v-for="(item, index) in InsData" :key="`ins-${index}`">
        <h4 :class="{'text-green':item.header.titleColor == 'green','text-insBlue':item.header.titleColor == 'blue'}">  
          <!-- 險種類型 -->
          {{ item.header.title }}
        </h4>
        <div class="segment bg-white">
          <table class="table">

            <!-- 保單名稱 -->
            <tr>
              <td colspan="2" v-html="item.header.content">
              </td>
            </tr>

            <!-- 保單相關內容 -->
            <tr v-for="(rowData, index) in item.contentList" :key="`rowData-${index}`">
              <th width="120" class="text-left">{{ rowData.title }}</th>
              <td v-html="rowData.content"></td>
            </tr>
          </table>
        </div>
      </div>
    </div>
  </main>
</template>

<script>
import {mapGetters, mapActions} from 'vuex'

export default {
  name: 'Insurance',
  computed: {
    ...mapGetters(['InsData']),
  },  
  data() {
    return {
      
    }
  },
  mounted () {
    document.body.onscroll = () => {
      let scroll = document.scrollTop || document.body.scrollTop || document.scrollingElement.scrollTop || 0;
      let go = document.querySelector('#gotop')
      if( scroll > 300) {
        go.classList.add('is-show')
      } else {
        go.classList.remove('is-show')
      }
    }
    this.registerHanlink()
  },
}
</script>
